import React, { useState, useCallback, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { bootstrapUser } from '../../store/slices/authSlice';
import Header from './Header';
import Sidebar from './Sidebar';
import './Layout.css';

const Layout = () => {
  const dispatch = useDispatch();
  const { token, bootstrapped, isLoading } = useSelector((state) => state.auth);

  // Local UI state hooks MUST appear before any return
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);
  const toggleSidebar = useCallback(() => setSidebarOpen(o => !o), []);

  // Bootstrap user when needed
  useEffect(() => {
    if (token && !bootstrapped && !isLoading) {
      dispatch(bootstrapUser());
    }
  }, [token, bootstrapped, isLoading, dispatch]);

  // Close sidebar automatically when resizing to desktop
  useEffect(() => {
    const onResize = () => { if (window.innerWidth >= 992) setSidebarOpen(false); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Lock body scroll when mobile sidebar open
  useEffect(() => {
    if (sidebarOpen) document.body.classList.add('no-scroll');
    else document.body.classList.remove('no-scroll');
  }, [sidebarOpen]);

  // Auth gate
  if (!token) return <Navigate to="/login" replace />;
  // Wait for bootstrap to avoid flicker
  if (token && !bootstrapped) return <div style={{ padding:'2rem' }}>Initializing session...</div>;

  return (
    <div className="layout">
      <Header>
        <button className="hamburger show-on-mobile" onClick={toggleSidebar} aria-label="Toggle navigation">☰</button>
      </Header>
      <div className="layout-body">
        <Sidebar open={sidebarOpen} onNavigate={closeSidebar} />
        <main className="main-content">
          <Outlet />
        </main>
        <div className={sidebarOpen ? 'sidebar-backdrop active' : 'sidebar-backdrop'} onClick={closeSidebar} />
      </div>
    </div>
  );
};

export default Layout;